import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { AiReviewCounts } from "../../aiReview.types";
import { AiReviewSubRoute, ApiRoutesAiReview } from "../../constants/enums";

// V2: the number of items per status (the sidebar badge reads `open`).
export const requestGetReviewCount = async (): Promise<AiReviewCounts> =>
  await instance.get(buildUrl(ApiRoutesAiReview.Root, AiReviewSubRoute.Count));
